// extracted by mini-css-extract-plugin
export default {"root":"AdminStoriesListHeader_root__JDLqG","root_cell":"AdminStoriesListHeader_root_cell__UF7qJ"};